import { get } from "lodash";
import getDebtor from "./getDebtor";

const getDebtorId = state => get(getDebtor(state), "id", "");

export default getDebtorId;
